import { z } from 'zod';
import { paginationQuerySchema } from '../common/envelope.js';
export const listAuditLogsQuerySchema = paginationQuerySchema.extend({
    actorId: z.string().uuid().optional(),
    action: z.string().optional(),
    entityType: z.string().optional(),
    entityId: z.string().uuid().optional(),
    /** Substring match, same convention as `action` — an admin typing
     * "142.112" should find every row from that block. */
    ip: z.string().optional(),
    dateFrom: z.string().datetime().optional(),
    dateTo: z.string().datetime().optional(),
});
/** Admin ▸ Audit log's Source column (design/orion-crm-design/rendered-html/
 * AdminAudit.html) — computed once, server-side, in `toAuditLogResponse`
 * from real signals only: `sso` from the session's real `authMethod`,
 * `api` from a real `apiKeyId`, `system` from having neither an actor nor
 * an API key. Everything else recorded today happens through the
 * authenticated web app, so it's `web` — there's no other real channel to
 * distinguish yet (no CLI, no native mobile client). */
export const auditSourceSchema = z.enum(['web', 'api', 'sso', 'system']);
export const auditActorResponseSchema = z.object({
    id: z.string().uuid(),
    displayName: z.string(),
    kind: z.enum(['user', 'api_key']),
});
export const auditLogResponseSchema = z.object({
    id: z.string().uuid(),
    occurredAt: z.string().datetime(),
    actorType: z.string(),
    actor: auditActorResponseSchema.nullable(),
    action: z.string(),
    entityType: z.string(),
    entityId: z.string().uuid().nullable(),
    changes: z.record(z.string(), z.tuple([z.unknown(), z.unknown()])).nullable(),
    ip: z.string().nullable(),
    userAgent: z.string().nullable(),
    requestId: z.string().nullable(),
    source: auditSourceSchema,
});
//# sourceMappingURL=schemas.js.map